/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Operator_EmptyInputs */

const fr_vehicle_action_edit_operator_empty = /** @type {(inputs: Vehicle_Action_Edit_Operator_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non renseigné`)
};

const en_vehicle_action_edit_operator_empty = /** @type {(inputs: Vehicle_Action_Edit_Operator_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not provided`)
};

/**
* | output |
* | --- |
* | "Not provided" |
*
* @param {Vehicle_Action_Edit_Operator_EmptyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_operator_empty = /** @type {((inputs?: Vehicle_Action_Edit_Operator_EmptyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Operator_EmptyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_operator_empty(inputs)
	return en_vehicle_action_edit_operator_empty(inputs)
});